import ListContentWrapper from "components/ListContentWrapper";
import TablePagination from "components/Table/Pagination";
import usePagination from "components/Table/Pagination/usePagination";
import PageInfoHeader from "ds/components/PageInfoHeader";
import TableSimple from "ds/components/TableSimple";
import useErrorHandle from "hooks/useErrorHandle";

import ScanRunsEmptyState from "./components/EmptyState";
import SCAN_RUNS_TABLE_CELLS from "./components/Table/Cells";
import {
  SCAN_RUNS_LIMIT,
  SCAN_RUNS_LIMIT_STORAGE_KEY,
  SCAN_RUNS_PAGINATION_OPTIONS,
} from "./components/Table/constants";
import useScanRunsTableStore from "./components/Table/useStore";
import useScanRuns from "./useScanRuns";

const ScanDetailScans = () => {
  const { runs, error, loadingContent, hasRows, loadScanRuns, endCursor, startCursor, totalCount } =
    useScanRuns();

  const {
    rowsPerPage,
    setRowsPerPage,
    from,
    to,
    lastPage,
    page,
    goToNextPage,
    goToPrevPage,
    goToFirstPage,
    goToLastPage,
  } = usePagination({
    fetchItems: loadScanRuns,
    endCursor,
    startCursor,
    allItemsCount: totalCount,
    visibleItemsCount: runs.length,
    initialLimit: SCAN_RUNS_LIMIT,
    storageKey: SCAN_RUNS_LIMIT_STORAGE_KEY,
  });

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <>
      <PageInfoHeader title="Scan runs" />

      <ListContentWrapper>
        {(hasRows || loadingContent) && (
          <>
            <TableSimple
              data={runs}
              loading={loadingContent}
              store={useScanRunsTableStore}
              ariaLabel="Scan runs table"
              cellPerColumn={SCAN_RUNS_TABLE_CELLS}
              rowsPerPage={rowsPerPage}
              hasPagination
            />
            <TablePagination
              from={from}
              to={to}
              loading={loadingContent}
              goToNextPage={goToNextPage}
              setRowsPerPage={setRowsPerPage}
              goToPrevPage={goToPrevPage}
              goToFirstPage={goToFirstPage}
              goToLastPage={goToLastPage}
              rowsPerPage={rowsPerPage}
              itemsCount={totalCount}
              lastPage={lastPage}
              page={page}
              paginationOptions={SCAN_RUNS_PAGINATION_OPTIONS}
            />
          </>
        )}

        {!hasRows && !loadingContent && <ScanRunsEmptyState />}
      </ListContentWrapper>
    </>
  );
};

export default ScanDetailScans;
